import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartIcon = ({ onClick, variant = 'light' }) => {
  const { getCartCount } = useCart();
  const count = getCartCount();

  const isDark = variant === 'dark';

  return (
    <button
      onClick={onClick}
      className={`relative p-2 transition-opacity hover:opacity-70 ${isDark ? 'text-white' : 'text-black'}`}
      data-testid="cart-icon"
      aria-label="Carrito"
    >
      <ShoppingBag className="w-6 h-6" strokeWidth={1.5} />
      {count > 0 && (
        <span
          className={`absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-bold rounded-full ${
            isDark ? 'bg-white text-black' : 'bg-black text-white'
          }`}
          data-testid="cart-count"
        >
          {count}
        </span>
      )}
    </button>
  );
};

export default CartIcon;
